import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const GifIcon = (props: IconProps) => (
  <Icon w="24px" h="24px" viewBox="0 0 24 24" {...props}>
    <circle
      cx="11.5"
      cy="11.8052"
      r="10.5"
      strokeWidth="2"
      fill="none" /*do not remove this */
    />
    <path
      strokeWidth="0"
      d="M12.7654 9.07629h-1.4729v5.84741h1.4729V9.07629ZM8.83757 9.07629H5.89164c-.58918 0-.98197.48729-.98197.97461v3.8983c0 .4873.39279.9745.98197.9745h2.94593c.58918 0 .98197-.4872.98197-.9745V12H8.34658v1.4619H6.38263v-2.9237h3.43691v-.4873c0-.48732-.39279-.97461-.98197-.97461ZM18.6572 10.5382V9.07629h-4.4189v5.84741h1.4729v-1.9491h1.964v-1.4619h-1.964v-.9745h2.946Z"
    />
  </Icon>
);
export default memo(GifIcon);
